import { dashboardApi } from './dashboardApi';

export const dashboardStorage = {
  // Save dashboard (create or update)
  save: async (dashboard) => {
    try {
      const dashboardName = dashboard.title || dashboard.uid || `dashboard_${Date.now()}`;
      // Check if dashboard exists
      try {
        await dashboardApi.getDashboardByName(dashboardName);
        // Exists - update it
        const response = await dashboardApi.updateDashboard(dashboardName, dashboard);
        if (response.status === 'ok' || response.status === 'success') {
        return { success: true, dashboardName: dashboardName, isNew: false };
      } else {
        return { success: false, error: 'Unexpected response status' };
      }
      } catch (error) {
        // Doesn't exist - create it
        const response = await dashboardApi.createDashboard(dashboardName, dashboard);
        if (response.status === 'ok' || response.status === 'success') {
        return { success: true, dashboardName: dashboardName, isNew: true };
      } else {
        return { success: false, error: 'Unexpected response status' };
      }
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  },

  // Load dashboard by name
  load: async (dashboardName) => {
    try {
      const response = await dashboardApi.getDashboardByName(dashboardName);
    if ((response.status === 'ok' || response.status === 'success') && response.dashboard) {
      return { 
        success: true, 
        data: response.dashboard.dashboard // Extract nested dashboard JSON
      };
    }
      return { success: false, error: 'Dashboard not found' };
    } catch (error) {
      console.error('Error loading dashboard:', error);
      return { success: false, error: error.message };
    }
  },

  // List all dashboards
  list: async () => {
    try {
      const response = await dashboardApi.listDashboards(false); // Don't include full payload
    if ((response.status === 'ok' || response.status === 'success') && response.dashboards) {
      return response.dashboards.map(d => ({
        name: d.dashboard_name,
        title: d.title,
        createdAt: d.created_at,
        updatedAt: d.updated_at,
        version: d.version,
        createdBy: d.created_by,
        updatedBy: d.updated_by
      }));
    }
      return [];
    } catch (error) {
      console.error('Error listing dashboards:', error);
      return [];
    }
  },

  // Delete dashboard
  delete: async (dashboardName) => {
    try {
      await dashboardApi.deleteDashboard(dashboardName);
      return { success: true };
    } catch (error) {
      console.error('Error deleting dashboard:', error);
      return { success: false, error: error.message };
    }
  },

  // No longer needed - using backend
  clear: () => {
    console.warn('Clear not supported with backend storage');
  }
};